"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonResponseHandler = void 0;
var CommonResponseHandler = /** @class */ (function () {
    function CommonResponseHandler() {
    }
    /**
     * 通用请求响应处理
     * @param response
     */
    CommonResponseHandler.prototype.handle = function (result) {
        if (result.error) {
            return { error: result.error };
        }
        var _a = result.data, status = _a.status, data = _a.data;
        var CommonRequestResult = {
            status: status,
            retcode: data === null || data === void 0 ? void 0 : data.retcode,
            message: data === null || data === void 0 ? void 0 : data.retmsg,
            data: data === null || data === void 0 ? void 0 : data.Data,
        };
        return CommonRequestResult;
    };
    return CommonResponseHandler;
}());
exports.CommonResponseHandler = CommonResponseHandler;
